document.addEventListener("DOMContentLoaded", () => {
  const banners = document.querySelectorAll("[data-parallax-banner]");
  if (!banners.length) return;

  let ticking = false;

  function updateParallax() {
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    banners.forEach((banner) => {
      const imageWrapper = banner.querySelector("[data-parallax-image]");
      if (!imageWrapper) return;

      const rect = banner.getBoundingClientRect();

      // Optional: disable on small screens
      if (window.innerWidth < 768) {
        imageWrapper.style.transform = "translateY(0)";
        return;
      }

      if (rect.bottom > 0 && rect.top < windowHeight) {
        const progress = rect.top / windowHeight; // 1 at top, 0 around center
        const offset = progress * 0;            // tweak -80 for more/less movement
        imageWrapper.style.transform = `translateY(${offset}px)`;
      }
    });

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  window.addEventListener("scroll", onScroll);
  updateParallax();
});
